import IComponent from "components/commons/IComponent";
import "./MiniPanel.scoped.css";

class MiniPanel extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed || props.defaultCollapsed || false,
    };
  }
  componentDidMount() {}
  componentWillUnmount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.defaultCollapsed != this.props.defaultCollapsed) {
      this.setState({ collapsed: this.props.defaultCollapsed });
    }
  }
  render() {
    let collapsed =
      "collapsed" in this.props ? this.props.collapsed : this.state.collapsed;
    let darkMode = this.props.darkMode;
    return (
      <div
        className={`MiniPanel ${collapsed ? "collapsed" : ""}`}
        style={{ ...(this.props.style || {}) }}
      >
        <div
          className={`${this.props.removeDefaultClass ? "" : "panelTitle"} ${
            this.props.titleClass
          } ${darkMode ? "darkMode" : ""}`}
          style={this.props?.ResultList ? { padding: `0` } : {}}
        >
          <div style={{ width: `100%`, height: `100%` }}>
            {this.props.titleText}
          </div>
          {!("collapsed" in this.props) && (
            <span
              className={`button icon_s icn_${
                collapsed ? "open" : "close"
              }folder`}
              onClick={() => {
                this.setState({
                  collapsed: !collapsed,
                });
              }}
            />
          )}
        </div>
        <div className={`PanelContainer`}>{this.props.children}</div>
      </div>
    );
  }
}

export default MiniPanel;
